export const isJsonSchema = (schema) => {
  if (schema?.type === "JSON" && !schema?.children) {
    return true;
  }
  return false;
};